import * as actions from './taskCategory/actions'
import * as mutations from './taskCategory/mutations'
import * as getters from './taskCategory/getters'

import { dataProps } from './taskCategory/properties'

const state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/taskCategory.js